import React, { useState } from "react";
import Retesting_Testing_Form from "./retesting_Testing_Form/Replicate_Testing_Form";
import Retesting_Testing_table from "./retesting_Testing_table/Retesting_Testing_table";

function Retesting_Testing() {
  const [showTable, setShowTable] = useState(false);

  return (
    <>
      <div className="imperiality_Form_div">
        <Retesting_Testing_Form onProceed={() => setShowTable(true)} />
      </div>

      {showTable && (
        <div className="imperiality_table_div">
          <Retesting_Testing_table/>
        </div>
      )}
    </>
  );
}

export default Retesting_Testing;
